export default __webpack_public_path__ + "static/media/upArrow.4a7c2fcd.svg";